export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_19.b885f374.jpg";